import { DrugScreenPayload } from '@/forms/DrugScreenForm/types';
import useAPI from '@/hooks/useAPI';
import DrugScreenRepository from '@/repositories/DrugScreenRepository';
import { DrugScreensParams } from '@/repositories/DrugScreenRepository/types';

export const useDrugScreens = (params: DrugScreensParams) => {
  const drugScreenRepository = DrugScreenRepository();

  return useAPI({
    queryKey: ['getDrugScreens', params],
    queryFn: async () => {
      return await drugScreenRepository.getDrugScreens(params);
    }
  });
};

export const useDrugScreenPreview = ({
  drugScreenId,
  values
}: {
  drugScreenId?: string;
  values: DrugScreenPayload;
}) => {
  const drugScreenRepository = DrugScreenRepository();

  return useAPI({
    queryKey: ['previewDrugScreen', values, drugScreenId],
    queryFn: async () => {
      return await drugScreenRepository.previewDrugScreen({
        drugScreenId,
        values
      });
    }
  });
};
